import React, { useEffect, useState, useRef } from "react";
import PropTypes from 'prop-types';
import { useTranslation } from "react-i18next";
import i18next from "i18next";

import className from "./style.module.scss";

export function ComparisonTabs(props) {

    const {
        t,
        // i18n
    } = useTranslation("translation");

    const lang = i18next.language;
    import(`./locales/${lang}/translation.json`)
        .then((data) => {
            i18next.addResourceBundle("en", "translation", data, true, true);
        })
        .catch((error) => {
            console.error("Error loading translation:", error);
        });


    const [totalActiveTabs, setTotalActiveTabs] = useState(1);
    const [activeTabs, setActiveTabs] = useState([]);
    const [loaded, setLoaded] = useState(false);

    const totalActiveTabsRef = useRef(totalActiveTabs);
    const updateTotalActiveTabs = data => {
        totalActiveTabsRef.current = data;
        setTotalActiveTabs(data);
    };
    const loadedRef = useRef(loaded);
    const updateLoaded = data => {
        loadedRef.current = data;
        setLoaded(data);
    };

    useEffect(() => {
        init_activeTabs();

        checkSizeConditions();
        window.addEventListener("resize", checkSizeConditions);
        return () => {
            window.removeEventListener("resize", checkSizeConditions);
        };
    }, []);

    useEffect(()=>{
        init_activeTabs();
        checkSizeConditions();
    }, [totalActiveTabs, props.tabsData.length])

    const init_activeTabs = () => {
        const updatedActiveTabs = [];
        for (let i = 0; i < totalActiveTabs; i++) {
            updatedActiveTabs.push(i);
        }
        setActiveTabs([...updatedActiveTabs]);
    };

    const checkSizeConditions = () => {
        updateLoaded(false);
        const maxWidth = props.tabMaxWidth;
        const maxWidthElem = document.getElementById(`tabContent_${props.widgetID}`);
        const widthLimit = maxWidthElem.clientWidth;
        let updatedTotalActiveTabs = totalActiveTabsRef.current;

        if(maxWidth*(totalActiveTabsRef.current + 1) <= widthLimit){
            if(props.tabsData.length >= totalActiveTabsRef.current + 1){
                updatedTotalActiveTabs++;
                updateTotalActiveTabs(updatedTotalActiveTabs);
            }
            else{updateLoaded(true);}
        }
        else if(maxWidth*totalActiveTabsRef.current > widthLimit){
            if(totalActiveTabsRef.current !== 1){
                updatedTotalActiveTabs--;
                updateTotalActiveTabs(updatedTotalActiveTabs);
            }
            else{updateLoaded(true);}
        }
        else {
            updateLoaded(true);
        }
    };

    const selectTab = (index) => {
        let updatedActiveTabs = activeTabs;
        if (activeTabs.includes(index)) {
            updatedActiveTabs = [];
            activeTabs.map((tab)=>{
                if(tab !== index){
                    updatedActiveTabs.push(tab);
                }
            })
            updatedActiveTabs.push(index);
        }
        else {
            updatedActiveTabs.shift();
            updatedActiveTabs.push(index);
        }
        setActiveTabs([...updatedActiveTabs]);
    };

    const renderTabs = () => {
        if(totalActiveTabs <= props.tabsData.length - 1){
            return (
                <nav id={`tabNav_${props.widgetID}`} className={className.TabsNav}>
                    {props.tabsData.map((tab, index) => {
                        return (
                            <button
                                key={index}
                                className={`${className.Tab} ${activeTabs.includes(index) ? className.Active : ""} ${totalActiveTabs === props.tabsData.length ? className.AllActive : ""}`}
                                tabIndex={0}
                                onClick={() => { selectTab(index) }}
                                aria-label={activeTabs.includes(index) ? t(`The '{{tabName}}' tab is active.`, {"tabName": t(`${tab.title}.string`)}) : t(`Set the '{{tabName}}' tab as active.`, {"tabName": t(`${tab.title}.string`)})}
                                style={{width: props.tabMaxWidth}}
                            >
                                {t(`${tab.title}.string`)}
                            </button>
                        )
                    })}
                </nav>
            )
        }
        else return null;
    };

    const renderTabConent = () => {
        return (
            <div id={`tabContent_${props.widgetID}`} className={`${className.ComparisonTabsContent} ${totalActiveTabs === props.tabsData.length ? className.AllActive : ""}`}>
                {props.tabsData.map((tab, index) => {
                    if (activeTabs.includes(index) && loaded) {
                        return (
                            <div 
                                id={`tabContent_${props.widgetID}_${index}`}
                                className={`${className.TabContentContainer} ${totalActiveTabs === props.tabsData.length ? className.AllActive : ""}`}
                                key={index}
                                style={{width: props.tabMaxWidth}}
                            >
                                {totalActiveTabs !== 1 || totalActiveTabs === props.tabsData.length ? 
                                    <h3>{t(`${tab.title}.string`)}</h3> : 
                                null}
                                {props.children[index]}
                            </div>
                        )
                    }
                })}
            </div>
        )
    };

    return (
        <div className={className.ComparisonTabsContainer}>
            {renderTabs()}
            {renderTabConent()}
        </div>
    );
}

ComparisonTabs.propTypes = {
    tabsData: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string.isRequired,
        })
    ).isRequired,
    tabsContentComponents: PropTypes.arrayOf(
        PropTypes.element.isRequired,
    ).isRequired,
    tabMaxWidth: PropTypes.number,
};
ComparisonTabs.defaultProps = {
    tabMaxWidth: 375,
};
